import { Platform, Vibration } from 'react-native';

/** Beep corto para comanda nueva (web) o vibración (native). */
export function playKitchenAlertSound(): void {
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const Ctx = (window as any).AudioContext || (window as any).webkitAudioContext;
      if (!Ctx) return;
      const ctx = new Ctx();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = 880;
      gain.gain.setValueAtTime(0.12, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.35);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start();
      osc.stop(ctx.currentTime + 0.35);
      setTimeout(() => void ctx.close(), 400);
      return;
    }
    Vibration.vibrate([0, 120, 80, 120]);
  } catch {
    // ignore
  }
}
